module.exports = __webpack_public_path__ + "static/media/PDF_Disabled.875cd385.svg";